import graphql__a41a85507dfc76d9ece3 from "./__generated__/ProfileContributionRouteQuery.graphql.js";import { graphql } from "react-relay";
import { useParams } from "react-router";
import AppQueryRenderer from "../AppQueryRenderer";

import ContributionOverviewModal from "../ParticipativeModule/Visualizations/ContributionOverviewModal";
import ModalLoader from "../Modals/ModalLoader";
import ModalErrorBoundary from "../ErrorBoundaries/ModalErrorBoundary";

const ProfileContributionsRoute = props => {
  const { contributionSlug } = useParams();

  return (
    <AppQueryRenderer
      key={contributionSlug}
      query={ProfileContributionRouteQuery}
      variables={{ contributionSlug }}
      component={ContributionOverviewModal}
      additionalProps={props}
      loader={<ModalLoader />}
      ErrorBoundary={ModalErrorBoundary}
      // Avoid caching the result to ensure the view is updated if the contribution is
      // edited. We could also update the contribution when it's edited from the store,
      // but it would mean reloading all the answer previews data every time a
      // contribution is updated, or complexifying the system, and the cache here is not
      // so useful as it's not a frequently used view
      fetchPolicy="network-only"
    />
  );
};

const ProfileContributionRouteQuery = graphql__a41a85507dfc76d9ece3;

export default ProfileContributionsRoute;
